module.exports = __webpack_public_path__ + "img/C - 02.f50fb1c5.png";